<template>
  <nav aria-label="breadcrumb" class="mt-2 mt-sm-0">
    <h5>{{ currentPage }}</h5>
  </nav>
</template>

<script>
export default {
  name: "BreadcrumbsComponent",
  props: {
    currentPage: {
      required: true,
      type: String,
      default: "MiGPS"
    },
  },
};
</script>

<style scoped>
nav {
  display: flex;
  align-items: center;
}

nav h5 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

@media (max-width: 550px) {
  nav h5 {
    margin-top: 0;
  }
}
</style>
